<template>
  <!-- Provides the application the proper gutter -->
  <v-container fluid fill-height>
    <NavDrawer></NavDrawer>
    <AppBar>
      <v-snackbar
        :color="appMessage.color || 'primary'"
        :value="appMessage"
        :absolute="false"
        :top="appMessage.position && appMessage.position.indexOf('top') !== -1"
        :bottom="appMessage.position && appMessage.position.indexOf('bottom') !== -1"
        :left="appMessage.position && appMessage.position.indexOf('left') !== -1"
        :right="appMessage.position && appMessage.position.indexOf('right') !== -1"
        :multi-line="appMessage.multiLine"
        :timeout="appMessage.timeout"
        v-if="appMessage"
      >
        {{ appMessage.text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="grey darken-4" text v-bind="attrs" @click="closeNotify()">Close</v-btn>
          <v-btn color="grey darken-4" text v-bind="attrs" @click="closeNotify(appMessage.clickAction)" v-if="typeof appMessage.clickAction === 'function'">{{appMessage.clickLabel || 'More'}}</v-btn>
        </template>
      </v-snackbar>
    </AppBar>
    <v-container class="bg" fluid fill-height>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <router-view name="auth"></router-view>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AppBar from "@/components/AppBar";
import NavDrawer from "@/components/NavDrawer";

export default {
  name: "Auth",
  computed: {
    ...mapGetters("app", ["appMessage"]),
  },
  components: {
    AppBar,
    NavDrawer,
  },
};
</script>

<style lang="sass">
.bg
  background: url( '../assets/hero-bg.jpg') no-repeat center center
  background-size: cover

.large-form
  transform: scale(1.2)
  transform-origin: left
</style>